import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MINDATE = () => {
  return (
    <CardSection id="MINDATE" title="MINDATE">
      <Paragraph>
        두 개 이상의 날짜를 비교해서 가장 빠른 날짜를 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MINDATE(DATETIME_1, [DATETIME_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME_1</b>은 첫 번째 날짜입니다.
          </Li>
          <Li>
            <b>DATETIME_2, ... [선택 사항]</b>은 추가 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MINDATE(`Target-Ship-Date`, `Ship-Date`)</Paragraph>
        <Img src="computeMindate" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>MINDATE</b> 함수 사용 시 예외적인 상황에 대한 결과는 아래와
          같습니다.
          <Ul>
            <Li>날짜가 하나만 제공된 경우 제공된 날짜가 반환됩니다.</Li>
            <Li>텍스트 문자열이 있는 셀은 무시됩니다.</Li>
            <Li>빈 셀은 무시됩니다.</Li>
            <Li>오류가 있는 셀은 무시됩니다.</Li>
            <Li>datetime 객체가 발견되지 않으면 빈 셀이 반환됩니다.</Li>
          </Ul>
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
